export default __webpack_public_path__ + "static/bumpa-addproduct-new2-22310ba431638d4c9020a01cff790dba.mp4";